import React, { Component } from 'react';
import { Body, Header, Wrapper, FooterBar } from '../postStyles'
import JournalInfo from '../JournalInfo'

class WinterSurvivalJournal extends Component {
    render() {
        return (
            <Wrapper>
                <Header>
                    <img src="https://i.ibb.co/wdsyQ2f/winter.jpg" alt="cover"/>
                    <div className="info">
                        <h1>
                            a survival guide for the season.
                        </h1>
                        <div className="date">11/05/2021</div>
                    </div>
                </Header>
                <Body>
                    <div className="paragraph">
                    As unexpectedly as the arrival of the first snow fall in the midst of a sunny day, 
                    an inexplicable heaviness began to accumulate upon my heart from that day onwards. 
                    The initial snowfall that all those around me seemed to rejoice over held a different 
                    sentiment to me — a sadness that arises seasonally. Its ache is similar to the bitterness 
                    of a lingering frostbite, a presence that has grown familar from the winters before.
                    </div>
                    <div className="paragraph">
                    Bluntly expressed, my desire to live decreases by an observable magnitude upon the arrival 
                    of winter. Only a few days ago I have been running along with lightness beneath my feet. 
                    Now it feels as though I have scarcely enough strength to show up to the bare minimum of 
                    it all. A miscellenaous array of things suddenly gained a mountainous weight. The next 
                    breath feels somewhat more streneous and the vulnerability of my inadequacies a bit more 
                    unbearable. How am I holding on by a thread again, I wonder to myself, I thought I wouldn't 
                    feel this way again — downcast without an explicable cause.
                    </div>
                    <div className="paragraph">
                    As the daylight that illuminated my interior begins to feel innumerable miles away, I start 
                    to construct a guide for survival — recounting the silver linings that are worth holding onto 
                    and leaning into the remnants of simplicty that are life-giving. 
                    </div>
                    <div className="paragraph">
                    I don't know how I could survive this day by day. But I will survive this day by day.
                    </div>
                    <div className="paragraph">
                    There are a multitude of ways that I could steady my breath again. I recall waiting through 
                    the night to witness the luminescence of sunrise penetrating through the wintry woods. I recall 
                    tracing back to the rhythm of exhalation even as the effort required by the next breath felt 
                    insurmountable. <br/>This becomes my guide for survival, again and again.
                    </div>
                    <br/>
                    <br/>
                    <h4>focusing on one thing at a time. 🗒️</h4>
                    <div className="paragraph" style={{marginLeft: "2rem"}}>
                    The more drained I feel, the more prone I am to allow too-many tabs to occupy my mind and browser window. 
                    Squirming on the edge of my seat, reluctant to be present for anything and anxious to grab at whatever that 
                    delivers a quick surge of dopamine. Overwhelmed by too many things at once while not truly paying attention 
                    to anything in particular, yet underwhelmed by how little meaning  anything provides.
                    </div>
                    <div className="paragraph" style={{marginLeft: "2rem"}}>
                    What is immensely life-giving instead, is to focus on one thing at a time. Cultivate whatever is before me 
                    and let that be meaningful. If all I feel like all I have strength for is merely the step in front of me, 
                    then I can simply tread forward in this way. One step. <i>One step at a time.</i> If I do not have the capacity 
                    to show up to too many different things, then I will hold onto what feels truly meaningful to me, freeing 
                    myself from the distractions of the rest. It will be worthwhile giving my attention to one thing at a time, 
                    showing up sincerely to it all.
                    </div>
                    <br/>
                    <h4>sunlight. 🌞</h4>
                    <div className="paragraph" style={{marginLeft: "2rem"}}>
                    Currently I sit before the glass walls in QNC, outlooking the soft watercolour wash of sapphire and a golden 
                    tapestry of autumnal leaves. The vibrancy of the sunlight remains desipte the arrival of snow. A myriad of 
                    leaves sift gently underneath the illuminenscence, gradually swirling towards the ground like paint splatters 
                    across the path treaded over by innumerable students. I pause and simply remember the sight.
                    </div>
                    <div className="paragraph" style={{marginLeft: "2rem"}}>
                    There will be sunlight pouring in through the window and a watercolour blend of sunset every night. Even as 
                    the lens that I am viewing the world through dimmens in saturation, I attempt to lean into the warmth from 
                    these fragments of incandescence.
                    </div>
                    <br/>
                    <h4>endorphine. 🏋🏻</h4>
                    <div className="paragraph" style={{marginLeft: "2rem"}}>
                    I continued with the momentum I began a couple weeks ago, dragging myself off the bed and out of the 
                    door to show up at the gym even when I want to remain absolutely immobile all day. Perhaps it is 
                    remedial mixture of serotonin and endorphine. As sweat begins to drip down, my rampant thoughts subside 
                    and I feel grounded again.
                    </div>
                    <br/>
                    <h4>let go of expectations. 💛</h4>
                    <div className="paragraph" style={{marginLeft: "2rem"}}>
                    I cannot gather enough energy or focus to engage in what is considered to be productive on this Friday 
                    afternoon. So I set aside my pending tasks and attempting to be anchored in the mere sense of being 
                    instead. It nevertheless feels necessary, to pause from the world of perpetual motion and record in 
                    trueness what is unfolding within me.
                    </div>
                    <div className="paragraph" style={{marginLeft: "2rem"}}>
                    Lately, my miscellaneous aspirations and ambitions have been traded in for the desire to remain 
                    immobile and stare into nothingness. In a society that prioritizes productivity upon a pedestal, 
                    this does not feel like an acceptable thing to admit to. But I can no longer bind myself to the 
                    pace of breathlessly running forward. Perhaps there is healing to be encountered in the idleness. 
                    Perhaps it is about remembering that there is enough space to feel and to be human and that will 
                    be enough.
                    </div>
                    <br/>
                    <h4>anchor to the words. 📖</h4>
                    <div className="paragraph" style={{marginLeft: "2rem"}}>
                    If all is lost, there will be words to take refuge in. There will be laughters and conversations 
                    shared with other souls. There will be stories to read, song lyrics to hum to, podcasts to ponder 
                    upon, and poems that leave an imprint on my soul. Perhaps words are the most tangible vessels for 
                    what is lost in translation, leaving everything touched in a tender afterglow.
                    </div>
                    <br/>
                    <br/>
                    <div className="paragraph">
                    I have often looked forward to the unfolding of a new month, anticipating the subtle melodic shift 
                    each beginning brings. The arrival of November brings the music of its own. As the invincibility of 
                    sunlight fade to unveil the vulnerability of the cold, the change in the season comes as a reminder 
                    for a return towards a steadier rhythm and a recultivation of margins. I attend to its composition, 
                    tuning my pace accordingly.
                    </div>
                    <div className="paragraph">
                    Perhaps there is an invisible strength in the naming of my suffocation, for this is how I will begin 
                    to steady my breath again. I am somewhere between being okay and knowing that I will eventually be, 
                    in the halfway of dusk and daylight, nevertheless holding space for it all. Anchoring to the changing 
                    tides and holding onto every strand of silver lining — reminding myself innumerable times and over that 
                    this is all worth staying for.
                    </div>
                </Body>
                <FooterBar 
                previous={JournalInfo['pastimes']}
                next={JournalInfo['beingbelonging']}/>
            </Wrapper>
        )
    }
}

export default WinterSurvivalJournal